import { Record } from "immutable";
import { ALLERGENS_LOAD, ALLERGENS_LOAD_FAIL, ALLERGENS_LOAD_SUCCESS } from "../Dish/actions";
import {
    ALLERGENS_SAVE_IN_MENU,
    ALLERGENS_SAVE_IN_MENU_FAIL,
    ALLERGENS_SAVE_IN_MENU_SUCCESS,
    ARCHIVE_MENU,
    ARCHIVE_MENU_FAIL,
    ARCHIVE_MENU_SUCCESS,
    IS_CONNECTED_POS,
    IS_CONNECTED_POS_FAIL,
    IS_CONNECTED_POS_SUCCESS,
    MENU_LOAD,
    MENU_LOAD_FAIL,
    MENU_LOAD_SUCCESS,
    MENU_NEW_SAVE,
    MENU_NEW_SAVE_FAIL,
    MENU_NEW_SAVE_SUCCESS,
    MENU_UPDATE,
    MENU_UPDATE_FAIL,
    MENU_UPDATE_SUCCESS,
    NEW_MENU_LOAD,
    NEW_MENU_LOAD_FAIL,
    NEW_MENU_LOAD_SUCCESS,
    POS_CONNECTION,
    POS_CONNECTION_FAIL,
    POS_CONNECTION_SUCCESS,
    UPLOAD_MENUS_FROM_POS,
    UPLOAD_MENUS_FROM_POS_FAIL,
    UPLOAD_MENUS_FROM_POS_SUCCESS,
} from "./actions";

const menu = new Record({
    loading: false,
    is_connected_pos: false,
    pos_connected: false,
    uploaded_menus: [],
    allergens: [],    
    menu: {
        menu_is_archived: false,
        menu_name: "",
        selectedLocation: [],
        allFutureLocations: false, 
        menu_open_close_times:{},
        optional_date:{}
    }
})();

export default (state = menu, action) => {
    switch (action.type) {
        // Is POS Connected?
        case IS_CONNECTED_POS:
            return state.set("loading", true);
        case IS_CONNECTED_POS_SUCCESS:
            return state
                .set("loading", false)
                .set("is_connected_pos", action.data.is_connected_pos);
        case IS_CONNECTED_POS_FAIL:
            return state.set("loading", false);

        // Connection POS
        case POS_CONNECTION:
            return state.set("loading", true);
        case POS_CONNECTION_SUCCESS:
            return state
                .set("loading", false)
                .set("pos_connected", action.data.pos_connected);
        case POS_CONNECTION_FAIL:
            return state.set("loading", false);

        // Uploading Menus
        case UPLOAD_MENUS_FROM_POS:
            return state.set("loading", true);
        case UPLOAD_MENUS_FROM_POS_SUCCESS:
            return state
                .set("loading", false)
                .set("uploaded_menus", action.data.uploaded_menus);
        case UPLOAD_MENUS_FROM_POS_FAIL:
            return state.set("loading", false);

        // Allergens Load
        case ALLERGENS_LOAD:
            return state.set("allergens", []).set("loading", true);
        case ALLERGENS_LOAD_SUCCESS:
            return (
                state
                    .set("allergens", action.data.data)
                    // .set("dishAllergens", action.data.dishAllergens)
                    .set("loading", false)
            );
        case ALLERGENS_LOAD_FAIL:
            return state.set("loading", false);

        // Allergens Save
        case ALLERGENS_SAVE_IN_MENU:
            return state.set("loading", true);
        case ALLERGENS_SAVE_IN_MENU_SUCCESS:
            return state
                .set("loading", false)
                .set("allergens", action.data.data);
        case ALLERGENS_SAVE_IN_MENU_FAIL:
            return state.set("loading", false);

        // New Menu Load   
        case NEW_MENU_LOAD:
            return state
                .set("loading", true)
                .set("menu", {
                    menu_name: "",
                    selectedLocation: [],
                    allFutureLocations: false,                    
                    menu_is_archived: false,
                    menu_open_close_times:{},
                    optional_date:{
                        optional_start_date:"",
                        optional_end_date:""
                    }
                })

        case NEW_MENU_LOAD_SUCCESS:
            return state.set("loading", false)
        case NEW_MENU_LOAD_FAIL:
            return state.set("loading", false);

        // Menu Load 
        case MENU_LOAD:
            return state.set("loading", true);
        case MENU_LOAD_SUCCESS:
            return state
                .set("loading", false)
                .set("menu", {
                    menu_name: action.response.menu_name,
                    selectedLocation: action.response.selectedLocation,
                    allFutureLocations: action.response.allFutureLocations,                    
                    menu_is_archived: action.response.menu_is_archived,
                    menu_open_close_times: action.response.menu_open_close_times,
                    optional_date:{
                        optional_start_date: action.response.optional_date.optional_start_date,
                        optional_end_date: action.response.optional_date.optional_end_date
                    }
                })
        case MENU_LOAD_FAIL:
            return state.set("loading", false);                

        // New Menu Save
        case MENU_NEW_SAVE:
            return state.set("loading", true);
        case MENU_NEW_SAVE_SUCCESS:
            return state
            .set("loading", false)
            .set("menu", action.data.menu);
        case MENU_NEW_SAVE_FAIL:
            return state.set("loading", false);

        // Menu Update    
        case MENU_UPDATE:
            return state.set("loading", true);
        case MENU_UPDATE_SUCCESS:
            return state
            .set("loading", false)
            .set("menu", action.data.menu);
        case MENU_UPDATE_FAIL:
            return state.set("loading", false);

        // Menu Archivate   
        case ARCHIVE_MENU:
            return state.set("loading", true);
        case ARCHIVE_MENU_SUCCESS:
            return state
            .set("loading", false)
            .set("menu", { menu_is_archived: action.response.menu_is_archived})
        case ARCHIVE_MENU_FAIL:
            return state.set("loading", false);
        
        default:
            return state;
    }
};
